export const enum WatotoCareEntityType {
  DROPDOWN = 'DROPDOWN',
  MULTISELECT = 'MULTISELECT',
  TEXT = 'TEXT',
  HEADING = 'HEADING'
}
